import { DownloadIcon } from "@heroicons/react/outline";
import { Breadcrumbs } from "components/breadcrumbs";
import Button from "components/button";
import React from 'react';
import { Link } from "react-router-dom";
import { ImportPasscode } from "./components";

const PASSCODE_TEMPLATE_FILE_PATH = "/files/passcode_import_template.xlsx";

export const MassImportPasscodes: React.FC = () => {      
  return (
    <div className="wrapper">
      <Breadcrumbs
        customPageLabel="Create & Update Private code/email"
        additionalLabel={(
          <Link
            to={PASSCODE_TEMPLATE_FILE_PATH}
            target="_blank"
            download
          >
            <Button
              id="download_template"
              className="w-11 h-11 sm:w-auto"
            >
              <span className="sr-only">Sample Template</span>
              <DownloadIcon className="w-4 h-4" />{" "}
              <span className="hidden sm:block sm:ml-2">
                Sample Template
              </span>
            </Button>
          </Link>
        )}
      />
      <ImportPasscode />
    </div>
  );
};
